import React from "react";
import {withRouter} from "../../utils/tms-with-router/tms-with-router";
const TmsDevotees = () => {
  return <div>Hello, Welcome to Devotees</div>;
};
export default withRouter(TmsDevotees);
